<!--
 * @Author: Latte
 * @Date: 2021-09-09 14:20:30
 * @LAstEditors: Latte
 * @LastEditTime: 2021-12-02 08:56:39
 * @FilePath: \Siui.Cloud.Medical.Web\src\views\systemManagement\CSDocumentManagement\instrument\index.vue
-->
<template>
  <div class="app-container">
    <el-tabs v-model="activeName" @tab-click="handleClick" v-tab-change:activeName="setActiveName">
      <!-- 机器系列 -->
      <el-tab-pane :label="$t('systemManagement.CSDocument.instrumentSeries')" name="instrumentSeries">
        <keep-alive>
          <InstrumentSeries :init-search-value="instrumentSeriesInitSearchValue"
                            v-if="activeName === 'instrumentSeries'"/>
        </keep-alive>

      </el-tab-pane>

      <el-tab-pane v-if="isShowUserSeriesTab()" label="用户绑定设备记录" name="userDeviceRelation">
        <user-series-vo-list></user-series-vo-list>
      </el-tab-pane>

      <!-- 问题库管理 -->
      <el-tab-pane v-if="isShowDeviceQuestionTab()" label="问题库管理" name="adminQuestionManagement">
        <keep-alive>
          <admin-question-management v-if="activeName === 'adminQuestionManagement'"></admin-question-management>
        </keep-alive>

      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
import InstrumentSeries from '@/components/FileManagement/Instrument/instrumentSeries'
import UserReview from '@/components/FileManagement/User/userReview'
import AdminQuestionManagement from "@/components/FileManagement/Instrument/AdminQuestionManagement";
import UserSeriesVoList from "@/components/FileManagement/User/userSeriesVoList";
import {isVaild} from "@/utils/validate";

export default {
  components: {
    UserSeriesVoList,
    AdminQuestionManagement,
    InstrumentSeries,
    UserReview,
  },
  data() {
    return {
      activeName: 'instrumentSeries',
      instrumentSeriesInitSearchValue: ""
    }
  },
  created() {
    let instrumentSeriesInitSearchValue = this.$route.query.instrumentSeriesInitSearchValue
    if(isVaild(instrumentSeriesInitSearchValue)){
      this.instrumentSeriesInitSearchValue = instrumentSeriesInitSearchValue;
    }
  },
  methods: {
    /**
     * 切换 tab
     */
    handleClick() {
      // console.log('Click')
    },
    isShowUserSeriesTab() {
      return this.config.SHOW_USER_SERIES_TAB === "true";
    },
    isShowDeviceQuestionTab() {
      return this.config.SHOW_DEVICE_QUESTION_TAB === "true";
    }
  },
}
</script>

<style scoped lang="scss"></style>
